/*eslint-disable*/
import _ from 'lodash';
import { getDomainNames } from "./general";

export const isRequiredRule = (value) => {
    if (value) {
      return { isValid: true };
    }
    return { isValid: false };
};

const alphaNumericRegex = /^[0-9a-zA-Z][0-9a-zA-Z ]*$/

export const isValidAlphaNumericRule = (value) => {
  if (value && !alphaNumericRegex.test(value)) {
    return false;
  }
  return true;
};

// valid names are 2-50 characters long, spaces allowed
export const isValidName = (name) => {
  return (/^.{1,50}$/.test(name) && !([null, undefined].includes(name)))
}

// valid emails follow nonWhitespace@nonWhitespace.nonWhitespace format
export const isValidEmail = (email) => {
  return /^(?!.*its\.jnj\.com$)[^\s@]+@[^\s@]+\.[a-zA-Z]{1,}$/.test(email);
}
// valid phone numbers are 10 digits long
export const isValidPhoneNumber = (phoneNumber) => {
  return /^.{1,100}$/.test(phoneNumber)
}

export const isValidGroupId = (groupId) => {
  const specialCharactersRegex = /[!@#$%^&*()_+\-=\[\]{}':"\\|.<>\/?]+/
  return !specialCharactersRegex.test(groupId)
}

// domain name should correspond to env (dev/stg/prod)
export const isValidDomainName = (domainName) => {
  if(!domainName) return true;
  const validDomains = getDomainNames().map(domain => domain.value);
  return validDomains.includes(domainName)
}

export const isValidSendActivationEmail = (value) => {
  if(value == "") {
    return true
  }
  if (typeof value === 'boolean') { 
    return value === true || value === false; 
  }
  const lowerValue = value.toLowerCase(); 
  if (typeof value === 'string') { 
    return lowerValue === 'true' || value === 'false';
  }
  return false;
}

export const isValidLocale = (value) => {
  if(value) {
    return /^[a-z]{2}-[A-Z]{2}$/.test(value)
  }
  return true
}

export const isValidCountry = (value) => {
  if(value) {
    return /^[a-zA-Z]{2}$/.test(value)
  }
  return true
}

// valid emails follow nonWhitespace@nonWhitespace.nonWhitespace format
export const isValidSecondaryEmail = (email) => {
  if(email){
    return /^(?!.*its\.jnj\.com$)[^\s@]+@[^\s@]+\.[a-zA-Z]{1,}$/.test(email);
  }
  return true
}

export const isValidPreferredLanguage = lang => typeof lang === 'string' || lang == null;
  